import { PropertyTabId } from '../view-area/components/property-tabs/property-tabs.component';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BasicuserviewComponent } from '../basicuserview/basicuserview.component';

@Component({
  selector: 'app-basicmobileview',
  imports: [BasicuserviewComponent],
  templateUrl: './basicmobileview.component.html',
  styleUrl: './basicmobileview.component.scss'
})
export class BasicmobileviewComponent {

  @Input() selectedItem: any;
  @Input() activeTab: PropertyTabId = 'property';
  @Output() activeTabChange = new EventEmitter<PropertyTabId>();
  @Output() onClose = new EventEmitter<void>();
  @Output() lightboxOpen = new EventEmitter<number>();

  closeMobileView() {
    this.onClose.emit();
  }

}
